/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useState, useEffect } from 'react';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import {
  Alert as MaterialAlert,
  AlertTitle as MaterialAlertTitle,
} from '@material-ui/lab';
import classnames from 'classnames';

enum AlertEvent {
  SHOW = 'SHOW_ALERT',
}

enum AlertType {
  ERROR = 'error',
  WARNING = 'warning',
  INFO = 'info',
  SUCCESS = 'success',
}

enum AlertTitle {
  ERROR = 'Terjadi Kesalahan',
  WARNING = 'Warning',
  INFO = 'Info',
  SUCCESS = 'Berhasil',
}

interface AlertState {
  title: AlertTitle | string;
  message: string;
  type: AlertType;
}

interface AlertPayload {
  message: string;
  title?: string;
  duration?: number;
}

interface MappedPayloadToStateInterface {
  payload: AlertState;
  duration?: number;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
      '& > * + *': {
        marginTop: theme.spacing(2),
      },
    },
  })
);

const documentBody = document.body;

const setPayloadToState = (
  type: AlertType,
  message: string,
  title: AlertTitle | string,
  duration?: number
) => {
  return {
    payload: {
      type,
      title,
      message,
    },
    duration,
  };
};

export const showSuccessAlert = (payload: AlertPayload) => {
  const detail: MappedPayloadToStateInterface = setPayloadToState(
    AlertType.SUCCESS,
    payload.message,
    payload.title ? payload.title : AlertTitle.SUCCESS,
    payload.duration
  );
  documentBody.dispatchEvent(
    new CustomEvent(AlertEvent.SHOW, {
      detail,
    })
  );
};

export const showInfoAlert = (payload: AlertPayload) => {
  const detail: MappedPayloadToStateInterface = setPayloadToState(
    AlertType.INFO,
    payload.message,
    payload.title ? payload.title : AlertTitle.INFO,
    payload.duration
  );
  documentBody.dispatchEvent(
    new CustomEvent(AlertEvent.SHOW, {
      detail,
    })
  );
};

export const showErrorAlert = (payload: AlertPayload) => {
  const detail: MappedPayloadToStateInterface = setPayloadToState(
    AlertType.ERROR,
    payload.message,
    payload.title ? payload.title : AlertTitle.ERROR,
    payload.duration
  );
  documentBody.dispatchEvent(
    new CustomEvent(AlertEvent.SHOW, {
      detail,
    })
  );
};

export default function Alert() {
  const classes = useStyles();

  let timeOutHideAlert = null;
  const [showAlert, setShowAlert] = useState<boolean>(false);
  const [alertState, setAlertState] = useState<AlertState>({
    title: 'Lifepack',
    message: 'Healty Inside Fresh Outside',
    type: AlertType.INFO,
  });

  const hideAlert = (duration?: number) => {
    if (duration) {
      timeOutHideAlert = setTimeout(() => {
        setShowAlert(false);
      }, duration);
    }
  };

  const setPayloadIntoAlertState = ({
    payload,
    duration = 5000,
  }: MappedPayloadToStateInterface) => {
    setAlertState(payload);
    setShowAlert(true);
    hideAlert(duration);
  };

  useEffect(() => {
    documentBody.addEventListener(
      AlertEvent.SHOW,
      (event: CustomEventInit<MappedPayloadToStateInterface>) => {
        if (event.detail) {
          setPayloadIntoAlertState(event.detail);
        }
      }
    );
    return () => {
      documentBody.removeEventListener(AlertEvent.SHOW, () => null);
    };
  }, []);

  return (
    <div
      className={classes.root}
      style={{
        display: showAlert ? 'block' : 'none',
        position: 'sticky',
        top: '0',
        left: '0',
        zIndex: 999,
      }}
    >
      <MaterialAlert severity={alertState.type}>
        <MaterialAlertTitle>{alertState.title}</MaterialAlertTitle>
        {alertState.message}
      </MaterialAlert>
    </div>
  );
}

type AlertCompType = {
  visible: boolean;
  onClick: () => void;
  text: string;
  actionText: string;
  className?: string;
};

export const AlertBottom = (props: AlertCompType) => {
  const { visible, onClick, text, actionText, className } = props;
  return visible ? (
    <div className={classnames('alert', className)}>
      <div className="alert-head">
        <p className="no-margin">{text}</p>
      </div>
      <div className="alert-body">
        <p onClick={onClick}>{actionText}</p>
      </div>
    </div>
  ) : null;
};

export const AlertText = (props: AlertCompType) => {
  const { visible, onClick, text, actionText, className } = props;

  return visible ? (
    <div className="alert-promo">
      <p className={className}>{text}</p>
      <p onClick={onClick}>{actionText}</p>
    </div>
  ) : null;
};
